export default __webpack_public_path__ + "static/media/parkshare-hands-blue-pink.34801450.png";